import SurveyPage from './components/surveyPage';
import React from 'react';

function App() {
  return (
      <main>
          <SurveyPage/>
      </main>
  )
}

export default App;
